// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrAnuradhaTikheDietitianContent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "32px",
            textAlign: "left",
          }}
        >
          <img
            src="/Doctorprofile.png"
            alt="Dr. Anuradha Tikhe"
            style={{
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ddd",
              flexShrink: 0,
            }}
          />

          <div
            className="vertical-divider"
            style={{
              width: "2px",
              backgroundColor: "#ccc",
              height: "100%",
              minHeight: "160px",
              display: "none",
            }}
          ></div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              flex: 1,
              minWidth: "260px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
              className="content-container"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="inner-content"
              >
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Dr. Anuradha Tikhe
                  </h2>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Specialization:</strong> Your Steady Hand & Reassuring Voice
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Experience:</strong> 16+ Years specializing in Pregnancy Nutrition
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Degrees:</strong> BHMS, MPH (Mumbai), Certified Pregnancy Nutritionist, Certificate Of Prenatal & Postnatal Yoga
                  </p>
                </div>

                <div
                  className="vertical-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    height: "100%",
                    minHeight: "160px",
                    display: "none",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontStyle: "italic",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#444",
                      marginTop: "4px",
                    }}
                  >
                    "I've had the privilege of guiding thousands of mothers. Through all the changes in
                    medicine, one thing remains constant: the need for a calm, experienced hand to hold."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (min-width: 768px) {
            .vertical-divider {
              display: block !important;
            }
      
            .inner-content {
              flex-direction: row !important;
            }
          }
      
          @media (max-width: 767px) {
            .doctor-intro-container {
              flex-direction: column;
              align-items: center !important;
              text-align: center !important;
            }
      
            .inner-content {
              flex-direction: column !important;
              align-items: center !important;
              text-align: center !important;
            }
      
            .content-container {
              align-items: center !important;
              text-align: center !important;
            }
          }
        `}
      </style>


      <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
        <h3>My Philosophy on Pregnancy Care:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          Having been a doctor for many years, I've learned that my most important tool is listening. I provide a foundation of stability and experience. My approach is calm, patient, and methodical. In moments of panic or uncertainty, my job is to be the anchor—to reassure you with the confidence that comes from having safely navigated these waters many, many times before.
        </p>

        <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I joined Myprega because I see it as the perfection of the patient-doctor relationship. After decades in the field, I can say with certainty that their model of continuous, empathetic support is what mothers have always needed. Myprega allows me to share my years of experience in a more meaningful and personal way than ever before.
        </p>

        <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I am an amateur photographer, with a focus on landscapes. It teaches me patience and the art of observation. My wife and I enjoy long walks, and I find that the rhythm of walking is when I do my best thinking.
        </p>
      </div>

      <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          {/* Favourite Book */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              📖 Favourite Book
            </p>
            <p style={{ color: "#333" }}>
              The Art of Seeing – Aldous Huxley
            </p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Singer */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🎵 Favourite Singer
            </p>
            <p style={{ color: "#333" }}>Kumar Gandharva</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Pastime */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              📸 Favourite Pastime
            </p>
            <p style={{ color: "#333" }}>
              Landscape Photography <br />
              Long Walks with My Wife
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DrAnuradhaTikheDietitianContent;
